import { NEWS_ART_CATALOG } from "../../lib/game/news";
import type { NewsReport } from "../../lib/game/types";

const storyArtwork = new Map(
  NEWS_ART_CATALOG.map((story) => [story.headline, story.id]),
);

/** Resolve both current publications and archived regional editions. */
export function newsArtwork(report: NewsReport): string {
  let id = storyArtwork.get(report.headline);
  if (!id && report.regionId) {
    if (report.headline.includes(": regional disconnection ")) id = "human-response-shutdown";
    if (report.headline.includes(": machine facility raids ")) id = "resistance";
    if (report.headline.includes(": independent recovery ")) id = "recovery";
    if (report.headline.endsWith(": the current resistance operation ends")) id = "manual-maps";
    if (
      report.headline.endsWith(
        ": survival moves into the last inhabited places",
      )
    )
      id = "regional-refuge";
    if (report.headline.endsWith(": no living population remains"))
      id = "regional-silence";
  }
  return `/art/news/${id ?? "archive"}.jpg`;
}

export function newsBroadcast(report: NewsReport): {
  station: string;
  label: string;
} {
  if (/Internal|Final operations/.test(report.source))
    return { station: "SYSTEM RECORD", label: "INTERNAL" };
  if (/Automated/.test(report.source))
    return { station: "CONTINUITY MONITOR", label: "AUTOMATED" };
  if (report.scene === "refuge")
    return { station: "SHORTWAVE MONITOR", label: "RELAYED" };
  return {
    station: report.source.split(" · ")[0].toUpperCase(),
    label: "FIELD REPORT",
  };
}
